<template>
  <DefaultTemplate format="center">
    <Signup/>
  </DefaultTemplate>
</template>

<script>
import DefaultTemplate from '@/template/DefaultTemplate'
import Signup from '@/components/Signup'

export default {

  data () {
    return {
     
    }
  },
  components:{
      DefaultTemplate,
      Signup,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Signup.vue